import { Routes, Route } from 'react-router-dom'
import { SessionProvider, useSessionContext } from './components/SessionProvider'
import { Toaster } from './components/ui/toaster'
import Layout from './components/layout/Layout'

// Pages
import Dashboard from './pages/Dashboard'
import FieldReports from './pages/FieldReports'
import SoftRooms from './pages/SoftRooms'
import Sessions from './pages/Sessions'
import SessionDetail from './pages/SessionDetail'
import Partners from './pages/Partners'
import Profile from './pages/Profile'
import AuthCallback from './pages/AuthCallback'
import NotFound from './pages/NotFound'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, status } = useSessionContext()

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (status === 'unauthenticated' || !session) {
    // Redirect to Clarity login
    const authUrl = import.meta.env.VITE_AUTH_URL || 'https://app.claritycm.com'
    const callbackUrl = encodeURIComponent(window.location.href)
    window.location.href = `${authUrl}/login?callbackUrl=${callbackUrl}`
    return null
  }

  return <>{children}</>
}

function AppRoutes() {
  return (
    <Routes>
      {/* Auth callback */}
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="field-reports" element={<FieldReports />} />
        <Route path="soft-rooms" element={<SoftRooms />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="sessions/:sessionId" element={<SessionDetail />} />
        <Route path="partners" element={<Partners />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

function App() {
  return (
    <SessionProvider>
      <AppRoutes />
      <Toaster />
    </SessionProvider>
  )
}

export default App
